// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ServicePriorities_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /so/service_priorities/remover
 *
 * Wire shape preserved from legacy: `dados: <int>` — the soft-deleted
 * record's so_service_priority_id emitted directly as a primitive integer.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ServicePriorities_RemoverResponseDados = number;

export type ServicePriorities_RemoverResponse = ApiResponse<ServicePriorities_RemoverResponseDados>;

registerResponseContract('ServicePriorities_RemoverResponse', {})
